// extracted by mini-css-extract-plugin
export default {"inputPrimary":"inputprimary_inputPrimary__ozJ1-"};